export default __webpack_public_path__ + "static/media/top_arrow_icon.f1166068.svg";